import React, {Component} from "react";
import PropTypes from 'prop-types';
import StyleableSection from "./StyleableSection";
import {Typography} from "@material-ui/core";

class TextSection extends Component {

  static propTypes = {
    section: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired
  };

  render() {
    let {section, locale} = this.props;

    locale = locale.replace('-', '_');

    const text = section.text.localizedStrings[locale];

    let style = {};
    if (section.textStyle) {
      style.color = section.textStyle.textColor;
      style.textAlign = section.textStyle.textAlign;
      style.fontFamily = section.textStyle.fontFamily;
      style.fontWeight = section.textStyle.fontWeight;
      style.fontSize = section.textStyle.fontSize;
      style.fontStyle = section.textStyle.fontStyle;
      style.margin = 0;
      style.padding = 0;
    }

    let tag = 'body1';
    if (section.tag) {
      tag = section.tag;
    }

    return (
      <StyleableSection section={section}>
        <Typography variant={tag} style={style}>
          {text}
        </Typography>
      </StyleableSection>
    );
  }

}

export default TextSection;
